import { render, staticRenderFns } from "./IncidentOttView.vue?vue&type=template&id=2bc90eee&"
import script from "./IncidentOttView.vue?vue&type=script&lang=js&"
export * from "./IncidentOttView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports